import Avatar from './Avatar.vue';

// @ts-ignore
Avatar.install = (Vue) => {
  Vue.component((Avatar as any).options.name, Avatar);
};

export default Avatar;
